{
  "cycle.entite.organisation_domaines": "Organisation domains",
  "journalAudit.action.org.domain.declared": "Domain declared",
  "journalAudit.action.org.domain.removed": "Domain removed",
  "journalAudit.action.org.domain.verification_failed": "Domain verification failed",
  "journalAudit.action.org.domain.verified": "Domain verified",
  "journalAudit.action.org.ip_restriction.denied": "Request refused: address outside allowed ranges",
  "v8c.securite.annuler": "Cancel",
  "v8c.securite.champ.adresse_invalide": "Invalid range: {{plage}}",
  "v8c.securite.champ.adresses": "Allowed addresses (one CIDR range per line)",
  "v8c.securite.champ.adresses_aide": "Empty list: no restriction. The organisation owner is exempt.",
  "v8c.securite.champ.adresses_cinquante": "At most 50 ranges.",
  "v8c.securite.champ.classes": "Required character types",
  "v8c.securite.champ.classes_bornes": "Between 1 and 4 types.",
  "v8c.securite.champ.domaines": "Domains allowed for invitations",
  "v8c.securite.champ.domaines_aide": "Only verified domains are offered (DNS proof below).",
  "v8c.securite.champ.domaines_tous": "No domain ticked: every e-mail address is accepted.",
  "v8c.securite.champ.duree": "Maximum session length",
  "v8c.securite.champ.duree_bornes": "Between 15 minutes and 30 days.",
  "v8c.securite.champ.duree_vide": "Unbounded",
  "v8c.securite.champ.longueur": "Minimum password length",
  "v8c.securite.champ.longueur_bornes": "Between 12 and 128 characters.",
  "v8c.securite.champ.second_facteur": "Require the second factor",
  "v8c.securite.champ.unite": "Length unit",
  "v8c.securite.champ.verrouillage": "Your current address ({{adresse}}) is not in these ranges: you will no longer be able to act from this address once saved.",
  "v8c.securite.code.ADRESSE_NON_AUTORISEE": "Your address is not in the organisation’s allowed ranges.",
  "v8c.securite.code.AUTH_POLICY_INVALID": "Invalid setting: check the ranges, the domains (verified only) and the bounds.",
  "v8c.securite.code.AUTH_POLICY_STALE": "The policy was changed in the meantime.",
  "v8c.securite.code.CONTEXTE_INCOMPLET": "The organisation context is incomplete.",
  "v8c.securite.code.DOMAINE_DANS_LA_POLITIQUE": "This domain is still allowed for invitations: remove it from the policy first.",
  "v8c.securite.code.DOMAINE_DEJA_VERIFIE_AILLEURS": "This domain is already verified by another organisation.",
  "v8c.securite.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v8c.securite.code.ORG_ADMIN_REQUIRED": "Reserved to the organisation administration.",
  "v8c.securite.code.RESOURCE_UNAVAILABLE": "Not found in your organisation.",
  "v8c.securite.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v8c.securite.code.VALIDATION_ERROR": "Invalid value.",
  "v8c.securite.col.actions": "Actions",
  "v8c.securite.col.compte": "Account",
  "v8c.securite.col.domaine": "Domain",
  "v8c.securite.col.second_facteur": "Second factor",
  "v8c.securite.col.statut": "Status",
  "v8c.securite.dialogue.copie": "Record copied.",
  "v8c.securite.dialogue.copie_refusee": "Copy refused by the browser: select the value.",
  "v8c.securite.dialogue.copier": "Copy the record",
  "v8c.securite.dialogue.domaine": "Domain",
  "v8c.securite.dialogue.domaine_repris": "Domain to resume",
  "v8c.securite.dialogue.en_cours": "Verification in progress…",
  "v8c.securite.dialogue.erreur_declaration": "Could not declare.",
  "v8c.securite.dialogue.erreur_verification": "Could not verify.",
  "v8c.securite.dialogue.exemple": "example.com",
  "v8c.securite.dialogue.fermer": "Close",
  "v8c.securite.dialogue.intro": "Enter the domain, install the TXT record at your DNS host, then verify.",
  "v8c.securite.dialogue.invalide": "Invalid domain name.",
  "v8c.securite.dialogue.masque": "The DNS proof appears once the domain is entered.",
  "v8c.securite.dialogue.nom": "Name",
  "v8c.securite.dialogue.obtenir": "Get the DNS proof",
  "v8c.securite.dialogue.plus_tard": "Try again later: DNS propagation can take time.",
  "v8c.securite.dialogue.preuve_titre": "Record to install for {{domaine}}",
  "v8c.securite.dialogue.statut.erreur_de_verification": "Verification error.",
  "v8c.securite.dialogue.statut.non_verifie": "Not verified",
  "v8c.securite.dialogue.statut.preuve_absente_ou_incorrecte": "Proof missing or incorrect: check the installed TXT record.",
  "v8c.securite.dialogue.statut.verification_en_cours": "Verification in progress",
  "v8c.securite.dialogue.titre": "Verify an organisation domain",
  "v8c.securite.dialogue.type": "Type",
  "v8c.securite.dialogue.valable": "Valid until verification.",
  "v8c.securite.dialogue.valeur": "Value",
  "v8c.securite.dialogue.verifier": "Verify now",
  "v8c.securite.domaines.confirmer_retrait": "Confirm removal of {{domaine}}",
  "v8c.securite.domaines.intro": "A domain verified by a DNS proof can be allowed for invitations.",
  "v8c.securite.domaines.libelle": "Organisation domains",
  "v8c.securite.domaines.reprendre": "Resume verification",
  "v8c.securite.domaines.reprendre_de": "Resume verification of {{domaine}}",
  "v8c.securite.domaines.reprise_echec": "Proof still not found for {{domaine}}.",
  "v8c.securite.domaines.reprise_erreur": "Could not verify.",
  "v8c.securite.domaines.reprise_verifie": "Domain {{domaine}} verified.",
  "v8c.securite.domaines.retirer": "Remove",
  "v8c.securite.domaines.retirer_de": "Remove {{domaine}}",
  "v8c.securite.domaines.retrait_empeche": "Remove it from the domains allowed for invitations first: the policy is never widened implicitly.",
  "v8c.securite.domaines.retrait_erreur": "Could not remove.",
  "v8c.securite.domaines.titre": "Organisation domains",
  "v8c.securite.domaines.verifie_le": "Verified on {{le}}",
  "v8c.securite.domaines.verifier_un_domaine": "Verify a domain",
  "v8c.securite.domaines.vide": "No domain declared.",
  "v8c.securite.effectif.filtre": "Second factor state",
  "v8c.securite.effectif.libelle": "Effective setting per account",
  "v8c.securite.effectif.pagination": "{{de}}–{{a}} of {{total}}",
  "v8c.securite.effectif.precedente": "Previous page",
  "v8c.securite.effectif.recherche": "Search an account",
  "v8c.securite.effectif.suivante": "Next page",
  "v8c.securite.effectif.titre": "Effective setting per account",
  "v8c.securite.effectif.tronquee": "List truncated to the first 200 accounts: refine the search.",
  "v8c.securite.effectif.vide": "No matching account.",
  "v8c.securite.enregistrer.annuaire_injoignable": "The directory is unreachable: save again later to catch up these accounts.",
  "v8c.securite.enregistrer.bouton": "Save and apply",
  "v8c.securite.enregistrer.conflit": "The policy was changed in the meantime: it was read again, check your settings and try again.",
  "v8c.securite.enregistrer.erreur": "Could not save.",
  "v8c.securite.enregistrer.resume_aide": "The summary is computed without saving anything.",
  "v8c.securite.enregistrer.resume_d_abord": "See the summary before applying",
  "v8c.securite.enregistrer.succes": "Policy saved and applied.",
  "v8c.securite.enregistrer.succes_partiel": "Policy saved; partly applied: the second factor could not be set for these accounts:",
  "v8c.securite.etat.chargement": "Loading: {{quoi}}…",
  "v8c.securite.etat.en_cours": "In progress…",
  "v8c.securite.etat.erreur": "Could not read: {{quoi}}.",
  "v8c.securite.etat.reessayer": "Retry",
  "v8c.securite.etat.refus": "Access denied: {{quoi}}.",
  "v8c.securite.etat_compte.a_configurer": "To set up at next sign-in",
  "v8c.securite.etat_compte.configure": "Second factor set up",
  "v8c.securite.etat_compte.en_echec_apres_application": "Failed after applying",
  "v8c.securite.etat_compte.inconnu_de_l_annuaire": "Unknown to the directory",
  "v8c.securite.etat_compte.non_configure": "Not set up",
  "v8c.securite.filtre.a_configurer": "To set up",
  "v8c.securite.filtre.configure": "Set up",
  "v8c.securite.filtre.en_echec_apres_application": "Failed after applying",
  "v8c.securite.filtre.non_configure": "Not set up",
  "v8c.securite.filtre.tous": "All",
  "v8c.securite.intro": "Second factor, session length, allowed domains and addresses: these rules apply to every member of the organisation.",
  "v8c.securite.onglet.membres": "Members",
  "v8c.securite.onglet.securite": "Sign-in security",
  "v8c.securite.onglets": "Organisation tabs",
  "v8c.securite.politique.adresses": "Allowed addresses",
  "v8c.securite.politique.domaines": "Domains allowed for invitations",
  "v8c.securite.politique.exige": "Required",
  "v8c.securite.politique.lecture_seule": "Read only: you do not hold the right to set sign-in security.",
  "v8c.securite.politique.libelle": "Policy in force",
  "v8c.securite.politique.mot_de_passe": "Password",
  "v8c.securite.politique.mot_de_passe_valeur": "At least {{n}} characters, {{c}} character type(s)",
  "v8c.securite.politique.non_exige": "Not required",
  "v8c.securite.politique.second_facteur": "Second factor",
  "v8c.securite.politique.session": "Maximum session length",
  "v8c.securite.politique.titre": "Policy in force",
  "v8c.securite.politique.tous_domaines": "All domains",
  "v8c.securite.politique.toutes_adresses": "No address restriction",
  "v8c.securite.politique.valeurs_par_defaut": "Default values: unbounded session, at least {{n}} characters, {{c}} character type.",
  "v8c.securite.politique.version": "Version {{v}}, changed on {{le}} by {{par}}.",
  "v8c.securite.reglages.titre": "Settings",
  "v8c.securite.resume.aucun_effet": "No effect on accounts, sessions or invitations.",
  "v8c.securite.resume.erreur": "Summary unavailable.",
  "v8c.securite.resume.invitations": "Invitations outside the ticked domains will be refused.",
  "v8c.securite.resume.second_facteur": "{{n}} people will have to set up the second factor.",
  "v8c.securite.resume.second_facteur_dont_vous": "{{n}} people will have to set up the second factor, including you.",
  "v8c.securite.resume.sessions": "Sessions longer than the new length will be closed.",
  "v8c.securite.resume.titre": "Summary before applying",
  "v8c.securite.session.heures": "{{n}} hours",
  "v8c.securite.session.jours": "{{n}} days",
  "v8c.securite.session.minutes": "{{n}} minutes",
  "v8c.securite.session.non_bornee": "Unbounded",
  "v8c.securite.statut.erreur_de_verification": "Verification error",
  "v8c.securite.statut.non_verifie": "Not verified",
  "v8c.securite.statut.preuve_absente_ou_incorrecte": "Proof missing or incorrect",
  "v8c.securite.statut.verification_en_cours": "Verification in progress",
  "v8c.securite.statut.verifie": "Verified",
  "v8c.securite.titre": "Organisation sign-in security",
  "v8c.securite.unite.heures": "hours",
  "v8c.securite.unite.jours": "days",
  "v8c.securite.unite.minutes": "minutes"
}
